//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Fields.js";
import "../no/NXObject.js";
let d=[[[0,"DefaultValue",0,0],[0,"Logarithmic",0,0],[0,"NameVariable",0,"Fields.NameVariable",0],[0,"NumPoints",0,0],[0,"Units",0,"Unit",0],[0,"VariableBounds",0,0],[0,"VariableType",0,0]],[],[]];
SPLM.Fields.FieldVariable = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Fields.FieldVariable";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Fields.FieldVariable.Bounds = class{
    constructor(isMinimumDefined,isMinimumInclusive,minimumValue,isMaximumDefined,isMaximumInclusive,maximumValue){
        this.isMinimumDefined=isMinimumDefined;this.isMinimumInclusive=isMinimumInclusive;this.minimumValue=minimumValue;this.isMaximumDefined=isMaximumDefined;this.isMaximumInclusive=isMaximumInclusive;this.maximumValue=maximumValue;}
    get Isminimumdefined(){return this.isMinimumDefined}
    set Isminimumdefined(val){this.isMinimumDefined = val}
    get Isminimuminclusive(){return this.isMinimumInclusive}
    set Isminimuminclusive(val){this.isMinimumInclusive = val}
    get Minimumvalue(){return this.minimumValue}
    set Minimumvalue(val){this.minimumValue = val}
    get Ismaximumdefined(){return this.isMaximumDefined}
    set Ismaximumdefined(val){this.isMaximumDefined = val}
    get Ismaximuminclusive(){return this.isMaximumInclusive}
    set Ismaximuminclusive(val){this.isMaximumInclusive = val}
    get Maximumvalue(){return this.maximumValue}
    set Maximumvalue(val){this.maximumValue = val}
};

SPLM.Fields.FieldVariable.Type = Object.freeze({
    "Unknown" : "Unknown", "Independent" : "Independent", "Dependent" : "Dependent"});

SPLM.Fields.FieldVariable.ValueType = Object.freeze({
    "Real" : "Real", "Imaginary" : "Imaginary", "ComplexRealImaginary" : "ComplexRealImaginary", "ComplexMagnitudePhase" : "ComplexMagnitudePhase", "Complex" : "Complex", "Integer" : "Integer"});

export default SPLM;